<script setup lang="ts">
import type { LicenseDetails } from '~~/types/LicenseDetails'

const { licenseDetails } = defineProps<{
  licenseDetails: LicenseDetails[]
}>()

const activeDetails = computed(() =>
  licenseDetails.filter(({ isExpired }) => !isExpired))
</script>

<template>
  <ul>
    <li
      v-for="details in activeDetails"
      :key="details.ean"
    >
      <ModusCollapsibleRoot>
        <ModusCollapsibleTrigger class="trigger">
          {{ details?.name }}
        </ModusCollapsibleTrigger>
        <ModusCollapsibleContent>
          <div class="wrapper">
            <CommonTypography variant="body">
              {{ $t('licenseDetails.ISBN') }}: {{ details?.ean }}
            </CommonTypography>
            <CommonTypography variant="body">
              {{ $t('licenseDetails.validTo') }}: {{ details?.endDate }}
            </CommonTypography>
            <CommonTypography variant="body">
              {{ $t('licenseDetails.licenseType') }}: {{ details?.licenseModel }}
            </CommonTypography>
          </div>
        </ModusCollapsibleContent>
      </ModusCollapsibleRoot>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
  ul, li {
    all: unset;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .trigger {
    font-family: inherit;
    width: 100%;
    padding: 1rem;
    background-color: var(--color-lightblue-10);
    color: var(--color-blue-50);
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    gap: 8px;
    background-color: var(--color-white);
    color: var(--color-blue-50);
    padding: 20px 24px 40px;
  }

  .wrapper > * {
    margin: 0;
  }
</style>
